import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";


import "../pages/Contact.css";
import Navbar from "../components/Navbar";
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import Footer from "../components/Footer";
export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us | RAD EnviroNex Madurai | Solar & Environmental Consultancy</title>
        <meta name="description" content="Get in touch with RAD EnviroNex in Madurai for solar panel installation, wastewater treatment, and environmental audits. Call us at +91 95978 39564." />
        <meta name="keywords" content="Contact RAD EnviroNex, Solar Company Madurai Address, Environmental Consultant Phone Number, Wastewater treatment service Madurai, RAD EnviroNex location" />
        <link rel="canonical" href="https://radenvironex.com/Contact" />
      </Helmet>
      <Navbar />


      {/* HERO */}
      <section className="contact-hero">
        <div className="container" data-aos="fade-up">
          <h1>Contact RAD EnviroNex</h1>
          <p>
            RAD environex- Nature inspired solution.
          </p>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="contact-info">
        <div className="container">
          <div className="row g-4">

            <div className="col-md-6 col-lg-3" data-aos="slide-up">
              <div className="contact-card">
                <MdPhone />
                <h4>Call Us</h4>
                <p>+91 95978 39564</p>

              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="100">
              <div className="contact-card">
                <FaWhatsapp />
                <h4>WhatsApp</h4>
                <a
                  href="https://wa.me/919597839564"
                  target="_blank"
                  rel="noreferrer"
                >
                  Chat on WhatsApp
                </a>
              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="200">
              <div className="contact-card">
                <MdEmail />
                <h4>Email</h4>
                <p>info@radenvironex.com</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3" data-aos="slide-up" data-aos-delay="300">
              <div className="contact-card">
                <MdLocationOn />
                <h4>Location</h4>
                <p>Address: Plot no :3, kannika street, duraiswamy nagar extn, Bypass road,madurai-625016</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* MAP + DISTRICTS */}
      <section className="contact-map">
        <div className="container">
          <div className="row align-items-start g-5">

            {/* MAP */}
            <div className="col-lg-7" data-aos="slide-right">
              <div className="map-box">
                <iframe
                  title="Madurai Map"
                  src="https://www.google.com/maps?q=Madurai,Tamil%20Nadu&output=embed"
                  loading="lazy"
                ></iframe>
              </div>
            </div>

            {/* DISTRICTS */}
            <div className="col-lg-5" data-aos="slide-left">
              {/* <h3 className="district-title">Service Coverage – Tamil Nadu</h3>

              <ul className="district-list">
                <li>Ariyalur</li><li>Chengalpattu</li><li>Chennai</li>
                <li>Coimbatore</li><li>Cuddalore</li><li>Dharmapuri</li>
                <li>Dindigul</li><li>Erode</li><li>Kallakurichi</li>
                <li>Kanchipuram</li><li>Kanyakumari</li><li>Karur</li>
                <li>Krishnagiri</li><li>Madurai</li><li>Mayiladuthurai</li>
                <li>Nagapattinam</li><li>Namakkal</li><li>Nilgiris</li>
                <li>Perambalur</li><li>Pudukkottai</li><li>Ramanathapuram</li>
                <li>Ranipet</li><li>Salem</li><li>Sivaganga</li>
                <li>Tenkasi</li><li>Thanjavur</li><li>Theni</li>
                <li>Thoothukudi</li><li>Tiruchirappalli</li><li>Tirunelveli</li>
                <li>Tirupathur</li><li>Tiruppur</li><li>Tiruvallur</li>
                <li>Tiruvannamalai</li><li>Tiruvarur</li><li>Vellore</li>
                <li>Viluppuram</li><li>Virudhunagar</li>
              </ul> */}

              {/* OPENING HOURS */}
              <div className="opening-hours" data-aos="fade-up">
                <h4>Office Hours</h4>
                <div className="hours-row">
                  <span>Monday – Saturday</span>
                  <strong>9:00 AM – 7:00 PM</strong>
                </div>
                <div className="hours-row closed">
                  <span>Sunday</span>
                  <strong>Closed</strong>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* EXTRA CONTENT */}
      <div className="coverage-note" data-aos="fade-up">
        <p>
          RAD EnviroNex operates across all districts of Tamil Nadu with
          project-specific deployment teams. Our service capability spans
          urban, semi-urban, and industrial zones, ensuring fast response,
          regulatory compliance, and consistent execution quality statewide.
        </p>
      </div>
      <Footer />
    </>
  );
}
